import { LocationId } from '../../commonv3/types/locations';
import { ImageRef } from './../../commonv3/types/image';

export enum LocationType {
  OFFICIAL_BASE = 'official_base',
  TEMPORARY = 'temporary',
}

export enum LocationStatus {
  ACTIVE = 'active',
  HIDDEN = 'hidden',
  ARCHIVED = 'archived',
}

export enum LocationKey {
  SHE_AOYAMA = 'she_aoyama',
  SHE_GINZA = 'she_ginza',
  SHE_NAGOYA = 'she_nagoya',
  SHE_UMEDA = 'she_umeda',
}

export type LocationIndexView = {
  id: LocationId;
  key: LocationKey | string;
  location_type: LocationType;
  status: LocationStatus;
  name: string;
  zipcode: string;
  address: string;
  access_summary: string;
  short_access_summary: string;
  access_description: string;
  google_map_url: string;
};

export type EditableLocation = {
  key: string;
  location_type: LocationType;
  status: LocationStatus;
  name: string;
  short_name: string;
  zipcode: string;
  address: string;
  access_summary: string;
  short_access_summary: string;
  access_description: string;
  google_map_url: string;
  image: ImageRef;
};
